export const Skeleton = {
	borderRadius: 'var(--epods--skeleton-border-radius)',
	rowHeight: 'var(--epods--skeleton-row-height)',
	rowMarginBottom: 'var(--epods--skeleton-margin-bottom)',
};
